import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { IgrDataGridModule, IgrTextColumn, IgrColumnGroupDescription, IgrGridColumnOptionsModule, HeaderClickAction, IgrTemplateHeader   } from 'igniteui-react-grids';
import { IgrDataGrid } from 'igniteui-react-grids';
import { DataSourceSectionHeaderDisplayMode } from 'igniteui-react-core';
import { getCashflowPositionByCurrency, getCashflowPositionByNostroId } from '../../networking/NetworkingDeals';

import LoadingBox from '../shared/LoadingBox';

import {getStyle} from '../../styles/styles';
import { de } from 'date-fns/locale';

var style = getStyle();
IgrDataGridModule.register();
IgrGridColumnOptionsModule.register();

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export default class CashProjectionTable extends React.Component{
    constructor(props){
        super(props);
        this.HorizontalRightHeader = new IgrTemplateHeader({});
        this.HorizontalRightHeader.cellUpdating = (s, e) => this.onHorizontalHeaderUpdating(s, e, "right");
    }

    state = {
        loading: false,
        open: false,
        columns: [],
        data: [],
    }
    
    componentDidUpdate = (prevProps) => {
        if(prevProps.open !== this.props.open) {
            if(this.props.open){
                this.setState({
                    loading: true,
                })
                this.loadCashFlows();
            }
        }
    }

    loadCashFlows = () => {
        getCashflowPositionByCurrency(this.props.currencyID).then((response) => {
            if (response.data) {
                let columnData = [];
                response.data.forEach(ele => {
                    ele.Group = ele['Balance Date'] + ' Total Credits: ' + ele['Total Credits'] + ' Total Debits: ' + ele['Total Debits'];
                    columnData.push(ele);
                })

                this.defineColumns(columnData);
                let finalData = [];
                columnData.forEach(ele => {
                    finalData.push(ele.Account);
                    ele.Balances.forEach(ele2=> { finalData.push(ele2); })
                    //finalData.push(ele.Balances);
                })
                //debugger;
                //finalData.push(response.data[0].Balances);
                //this.setState({open: true, data: finalData});
                this.setState({open: true, data: response.data[0].Balances});
                let groupDate = new IgrColumnGroupDescription();
                //groupDate.field = "Group";
                groupDate.field = "BankAccountNumber";
                groupDate.displayName = "";
                this.grid.groupDescriptions.add(groupDate);
                this.grid.isGroupCollapsable = true;
                this.grid.groupHeaderDisplayMode = DataSourceSectionHeaderDisplayMode.Combined;
            }
        });
    }
    
    onGridRef = (grid) => {
        if (!grid) { return; }
        this.grid = grid;
    }

    onHorizontalHeaderUpdating = (s, e, align) => {
        const content = e.content; //as HTMLDivElement;
        let label = null;
        if (content.childElementCount === 0) {
            content.style.lineHeight = "25px";
            label = document.createElement("div");
            label.style.background = "transparent";
            label.style.color = "rgb(24, 29, 31)";
            label.style.overflowWrap = "break-word"
            label.style.verticalAlign = "center";
            label.style.textAlign = align;
            content.appendChild(label);
        } else {
            label = content.children[0] ; //as HTMLDivElement;
        }

        const info = e.cellInfo; // as IgrTemplateCellInfo;
        label.textContent = info.value;
    }

    onClose = () => {
        this.setState({
            open: false,
            loading: false,
        })
        this.props.onClose();
    }

    defineColumns = (data) => {
        let columnHelper = [];
        let keys = Object.keys(data[0]);
        let accountKeys = Object.keys(data[0].Account);
        let balancesKeys = Object.keys(data[0].Balances[0]);
        /*accountKeys.forEach(element => {
            if (!element.includes('$')) {
                if(element === 'Currency' || element === 'Description' || element === 'Total' || element === 'Group' || element === 'BankAccountID' || element === 'Name' || element === 'Total Sold'){
                    if(element === 'Currency' || element === 'Group' || element === 'BankAccountID' || element === 'Name' || element === 'Total Sold') {
                        //columnHelper.push({key: element, name: '', lock: true});
                    } else {
                        columnHelper.push({key: element, name: capitalize(element), lock: true});
                    } 
                } else {
                    columnHelper.push({key: element, name: capitalize(element), lock: false});
                }
            }
        });*/        
        columnHelper.push({key: "Description", name: capitalize("Description"), lock: true});
        balancesKeys.forEach(element => {
            if (!element.includes('$')) {
                if(element === 'Currency' || element === 'Description' || element === 'Total' || element === 'BankAccountNumber' || element === 'BankAccountID' || element === 'Total Sold'){
                    if(element === 'Currency' || element === 'BankAccountNumber' || element === 'BankAccountID' || element === 'Total Sold') {
                        //columnHelper.push({key: element, name: '', lock: true});
                    } else {
                        columnHelper.push({key: element, name: capitalize(element), lock: true});
                    } 
                } else {
                    columnHelper.push({key: element, name: capitalize(element), lock: false});
                }
            }
        });
        //debugger;
        let columnDirectives = [];
        this.setState({columnsHelper: columnHelper});
        console.log(columnHelper);
        columnHelper.forEach(element => {
            if (element.lock) {
                if(element.key === "Description"){
                    columnDirectives.push(<IgrTextColumn key={element.key} pinned="left" field={element.key} headerText={element.name} width="200" horizontalAlignment="right"/>);
                } else {
                    columnDirectives.push(<IgrTextColumn key={element.key} pinned="left" field={element.key} headerText={element.name} width="200"/>);
                }
                
            } else {
                columnDirectives.push(<IgrTextColumn key={element.key} field={element.key} headerText={element.name} header={this.HorizontalRightHeader} width="200" horizontalAlignment="right"/>);
            }
            
        })
        //debugger;
        this.setState({columns: columnDirectives});
    }
    
    render(){
        return(
            <div>
                <Dialog open={this.state.open} onClose={this.onClose} fullWidth={true} maxWidth='lg'>
                    <DialogTitle>List of Cashflows</DialogTitle>
                    <DialogContent>
                        {
                            this.state.data.length < 0 && 
                            (<h5>No deals available.</h5>)
                        }
                        <IgrDataGrid
                                height="80vh"
                                width="100%"
                                dataSource={this.state.data}
                                ref={this.onGridRef}
                                autoGenerateColumns="false"
                                defaultColumnMinWidth="100"
                                isColumnOptionsEnabled="false"
                                headerClickAction={HeaderClickAction.None}
                                editMode="None"
                                selectionMode="SingleCell"
                                cornerRadiusTopLeft="0"
                                cornerRadiusTopRight="0"
                                >
                                    {this.state.columns}
                                </IgrDataGrid>
                    </DialogContent>
                    <DialogActions>
                        <button className="uk-button uk-button-green" key={"cancel"} type="button" onClick={this.onClose}>Close</button>
                    </DialogActions>
                </Dialog>
                <LoadingBox loading={this.state.loading}/>
            </div>

        );
    }
}